module.exports = __webpack_public_path__ + "static/media/group-3.a0427c0d.svg";